import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Container, Divider } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';
import OneLineTextInputComponent from '../manualecomponents/components/OneLineTextInputComponent';
import MultilineTextInputComponent from '../manualecomponents/components/MultilineTextInputComponent';
import FileUploader from '../manualecomponents/dettaglio_procedura/FileUploader';
import ActionButton from '../../../components/ActionButton';
import ModalSelezioneAssociazioneScheda from '../manuale_personalizzato/ModalSelezioneAssociazioneScheda.js';
import ModalSelezioneOrarioScheda from '../manuale_personalizzato/ModalSelezioneOrarioScheda.js';
import AggiuntaOpzioniColonnaModal from './AggiuntaOpzioniColonnaModal.jsx';
import {
  getGestioneOperativaReparti,
  getGestioneOperativaSchedaById,
  updateGestioneOperativaSchedaById,
} from '../../../utils/api/aggiornamentoGestioneOperativaApi.js';
import {
  getCategorieSchede,
  uploadSchedaImage,
} from '../../../utils/api/schede_api.js';

import PropTypes from 'prop-types';
import {
  getPDFForParagrafo,
  postAggiuntaPDFForParagrafo,
} from '../../../utils/api/paragrafi_api.js';
import DefinizioneColonneTable from './DefinizioneColonneTable.jsx';
import SchedaTable from './SchedaTable.jsx';
import ImageList from './ImageList.jsx';
import PdfList from './PdfList.jsx';
import CustomSnackbar from '../../../components/CustomSnackbar.js';
import NuovaCategoriaControlloModal from '../components/NuovaCategoriaControlloModal.jsx';
import {
  createCustomCategory,
  deleteCustomCategory,
  getCustomCategoriesByConsultantId,
} from '../../../utils/api/customCategoriesApi.js';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog.js';
import ReminderSection from './ReminderSection.jsx';
import { reminderFromDto, reminderToDto } from './reminderUtils.js';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../../../utils/messages';
import { reportApiError, reportError } from '../../../utils/reportApiError';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    padding: '26px 10px',
    minHeight: '90vh',
  },
  uploadWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  uploadContainer: {
    backgroundColor: '#f9f9f9',
    padding: theme.spacing(0, 2),
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '470px',
    width: '100%',
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(5),
  },
  dividerSpacing: {
    width: '85%',
    maxWidth: '1520px',
    margin: '16px auto',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    width: '85%',
    maxWidth: '1520px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const DettaglioSchedaEsercizio = ({ esercizioId, schedaId }) => {
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const isMounted = useRef(true);
  const { aggiornamentiGestioneOperativaId, consulenteId } =
    location.state || {};

  const [scheda, setScheda] = useState([{}]);

  const [categorieSchede, setCategorieSchede] = useState([]);
  const [reparti, setReparti] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUploadDisabled, setImageUploadDisabled] = useState(true);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [newImageFile, setNewImageFile] = useState(null);
  const [pdfUploadDisabled, setPdfUploadDisabled] = useState(true);
  const [newPdfFile, setNewPdfFile] = useState(null);

  const [isListaOrariDisabled, setIsListaOrariDisabled] = useState(false);
  const [isOrarioModalOpen, setIsOrarioModalOpen] = useState(false);
  const [isAssociazioneModalOpen, setIsAssociazioneModalOpen] = useState(false);
  const [isValoreModalOpen, setIsValoreModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isNuovaCategoriaModalOpen, setIsNuovaCategoriaModalOpen] =
    useState(false);
  const [edit, setEdit] = useState(false);
  const [reminderIsPartial, setReminderIsPartial] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
  });
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [twoActionsAlertDialog, setTwoActionsAlertDialog] = useState({
    open: false,
    title: '',
    message: '',
  });

  const handleOpenSnackbar = (message) => {
    setSnackbar({ open: true, message });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '' });
  };

  const normalizeSchedaData = (schedaData) =>
    schedaData.map((s) => {
      const isCustom = !!s.categoriaPersonalizzataId;
      // The reminder lives on as the English pair below; keeping the raw DTO
      // fields around too would leave the same value in the state twice.
      const { promemoriaStileVisivo, promemoriaMessaggio, ...schedaFields } = s;

      return {
        ...schedaFields,
        categoria: isCustom
          ? 'PERSONALIZZATA'
          : s.categoria || 'SCHEDA_GENERICA',
        cadenza: s.cadenza || 'ALTRO',
        titolo: s.titolo || '',
        descrizione: s.descrizione || '',
        reparti: s.reparti || [],
        immagini: s.immagini || [],
        definizioniColonne: s.definizioniColonne || [],
        cadenze: s.cadenze || [],
        periodico: s.periodico ?? false,
        calendarizzato: s.calendarizzato ?? false,
        categoriaPersonalizzataId: s.categoriaPersonalizzataId ?? null,
        ...reminderFromDto(s),
      };
    });
  const fetchData = async () => {
    setLoading(true);

    try {
      const responseScheda = await getGestioneOperativaSchedaById(
        aggiornamentiGestioneOperativaId,
        schedaId,
      );

      const responseCategorieStd = await getCategorieSchede();
      const responseCategorieCustom =
        await getCustomCategoriesByConsultantId(consulenteId);

      const std = responseCategorieStd
        .map((c) => ({
          ...c,
          isCustom: false,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      const custom = responseCategorieCustom
        .map((c) => ({
          value: c.nome.toUpperCase().replace(/\s+/g, '_'),
          label: c.nome,
          isCustom: true,
          id: c.id,
          unitaMisura: c.unitaMisura,
          tipoControllo: c.tipoControllo,
          consulenteId: c.consulenteId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      const responseReparti = await getGestioneOperativaReparti(
        aggiornamentiGestioneOperativaId,
      );

      if (isMounted.current) {
        const schedaNormalizzata = normalizeSchedaData(responseScheda.schede);
        setScheda(schedaNormalizzata);
        setCategorieSchede([...std, ...custom]);
        setReparti(responseReparti.reparti);
      }
    } catch (error) {
      reportApiError(error);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    isMounted.current = true; // Il componente è montato

    if (aggiornamentiGestioneOperativaId && schedaId) {
      fetchData();
    }

    return () => {
      isMounted.current = false; // Imposta il flag su `false` quando il componente viene smontato
    };
  }, [aggiornamentiGestioneOperativaId]);

  const handleChangeSchedaField = (event, field) => {
    const { value } = event.target;
    setScheda((prev) => [{ ...prev[0], [field]: value }]);
    setEdit(true);
  };

  const handleImageFileSelection = (event) => {
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    const imageFile = files[0];

    if (imageFile.type !== 'image/png') {
      reportError(
        'Possono essere caricate solo immagini in formato PNG.',
        'Attenzione',
      );
      return;
    }
    if (imageFile.size > 500000) {
      reportError(
        "La dimensione dell'immagine caricata è maggiore 500kB.",
        'Attenzione',
      );
      return;
    }

    setNewImageFile(imageFile);
    setImageUploadDisabled(false);
  };

  const uploadImage = (file) => {
    setUploadingImage(true);
    setImageUploadDisabled(true);

    uploadSchedaImage(file)
      .then((response) => {
        const imageId = response;
        confirmImageRegistration(imageId);
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => {
        setUploadingImage(false);
      });
  };

  const confirmImageRegistration = (id) => {
    const newImageObject = {
      id: id,
      titolo: '',
      note: '',
      posizione: (scheda[0]?.immagini || []).length,
    };

    setScheda((prev) => [
      { ...prev[0], immagini: [...(prev[0]?.immagini || []), newImageObject] },
    ]);
    setNewImageFile(null);
    setUploadingImage(false);
    setEdit(true);
  };

  const handlePdfFileSelection = (event) => {
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    const pdfFile = files[0];

    if (pdfFile.type !== 'application/pdf') {
      reportError(
        'Possono essere caricati solo documenti in formato PDF.',
        'Attenzione',
      );
      return;
    }

    if (pdfFile.size > 10000000) {
      reportError(
        'La dimensione del documento caricato è maggiore di 10MB.',
        'Attenzione',
      );
      return;
    }

    setNewPdfFile(pdfFile);
    setPdfUploadDisabled(false);
  };

  const uploadPdf = () => {
    const formData = new FormData();
    formData.append('file', newPdfFile);

    setUploadingImage(true);
    setPdfUploadDisabled(true);

    postAggiuntaPDFForParagrafo(formData)
      .then((response) => {
        const pdfId = response.id;
        confirmPdfRegistration(pdfId);
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => {
        setUploadingImage(false);
      });
  };

  const confirmPdfRegistration = (pdfId) => {
    const newPdfObject = {
      id: pdfId,
      note: '',
      posizione: scheda[0].files.length,
      titolo: newPdfFile.name,
    };

    setScheda((prev) => [
      { ...prev[0], files: [...(prev[0]?.files || []), newPdfObject] },
    ]);
    setNewPdfFile(null);
    setPdfUploadDisabled(true);
    setUploadingImage(false);
    setEdit(true);
  };

  const deleteImageAttachment = (id) => {
    setScheda((prev) => [
      {
        ...prev[0],
        immagini: prev[0].immagini
          .filter((item) => item.id !== id)
          .map((item, index) => ({ ...item, posizione: index })),
      },
    ]);
  };

  const deletePdfAttachment = (id) => {
    setScheda((prev) => [
      {
        ...prev[0],
        files: prev[0].files
          .filter((item) => item.id !== id)
          .map((item, index) => ({ ...item, posizione: index })),
      },
    ]);
  };

  const changeImageField = (value, index, field) => {
    setScheda((prev) => {
      const updatedImages = [...prev[0].immagini]; // Clona l'array delle immagini
      updatedImages[index] = { ...updatedImages[index], [field]: value };

      return [
        {
          ...prev[0],
          immagini: updatedImages,
        },
      ];
    });
  };

  const handlePdfView = (pdfId) => {
    if (!pdfId) {
      reportError(
        'ID PDF mancante. Non è possibile recuperare il documento.',
        'Errore',
      );
      return;
    }

    getPDFForParagrafo(pdfId)
      .then((response) => {
        if (response?.url) {
          window.open(response.url, '_blank');
        } else {
          reportError('URL PDF non disponibile.', 'Errore');
        }
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  const openOrarioModal = () => setIsOrarioModalOpen(true);

  const closeOrarioModal = () => setIsOrarioModalOpen(false);

  const openAssociazioneModal = () => setIsAssociazioneModalOpen(true);

  const closeAssociazioneModal = () => setIsAssociazioneModalOpen(false);

  const addRepartiToScheda = (selectedReparti) => {
    setScheda((prev) => {
      const repartoPredefinito = reparti
        .filter((reparto) => reparto.repartoDefault)
        .map((reparto) => reparto.id);

      const repartiSelezionati = selectedReparti
        .filter((reparto) => reparto.checked)
        .map((reparto) => reparto.idReparto);

      const nuoviReparti = [
        ...new Set([...repartoPredefinito, ...repartiSelezionati]),
      ]; // Unione eliminando i duplicati

      return [{ ...prev[0], reparti: nuoviReparti }];
    });
    setIsAssociazioneModalOpen(false);
  };

  const setCadenze = (cadenze) => {
    setScheda((prev) => [{ ...prev[0], cadenze }]);
    setIsOrarioModalOpen(false);
  };

  const handleNewRow = () => {
    const newColonnaObject = {
      nomeColonna: '',
      tipo: 'testo_libero',
      opzioni: [],
    };

    setScheda((prev) => {
      const colonneAttuali = prev[0].definizioniColonne || [];

      if (colonneAttuali.length >= 20) {
        reportError(
          'Non si possono aggiungere più di 20 colonne',
          'Attenzione',
        );
        return prev;
      }

      return [
        {
          ...prev[0],
          definizioniColonne: [...colonneAttuali, newColonnaObject],
          colonne: [...(prev[0].colonne || []), newColonnaObject.nomeColonna],
        },
      ];
    });
    setEdit(true);
  };

  const handleCategoriaChange = (event) => {
    const selectedValue = event.target.value;
    if (!selectedValue) return;

    const categoria = (categorieSchede || []).find(
      (cat) => cat.value === selectedValue,
    );

    setScheda((prev) => [
      {
        ...prev[0],
        categoria: selectedValue,
        categoriaPersonalizzataId: categoria.isCustom ? categoria.id : null,
        categoriaPersonalizzataNome: categoria.isCustom
          ? categoria.label
          : null,
      },
    ]);
    setEdit(true);
  };

  const handleCalendarizzatoChange = (event) => {
    const isCalendarizzato = event.target.value === true;

    setScheda((prev) => [
      {
        ...prev[0],
        calendarizzato: isCalendarizzato,
        cadenza: isCalendarizzato ? 'GIORNALIERA' : null,
        cadenze: [],
        periodico: isCalendarizzato ? prev[0].periodico : false,
      },
    ]);
    setIsListaOrariDisabled(!isCalendarizzato);
  };

  const handlePeriodicoChange = () => {
    setScheda((prev) => {
      const newPeriodico = !prev[0].periodico;
      const updatedScheda = [
        {
          ...prev[0],
          periodico: newPeriodico,
        },
      ];

      setIsListaOrariDisabled(newPeriodico);

      return updatedScheda;
    });
  };

  const handleCadenzaChange = (event) => {
    const nuovaCadenza = event.target.value || 'ALTRO';
    setScheda((prev) => {
      return [
        {
          ...prev[0],
          cadenza: nuovaCadenza,
          cadenze: [],
          periodico: false,
        },
      ];
    });
    setIsListaOrariDisabled(false);
    setEdit(true);
  };

  const handleColumnChange = (value, field, rowIndex) => {
    setScheda((prev) => {
      const newDefinizioni = prev[0].definizioniColonne.map((item, index) => {
        if (index !== rowIndex) return item;
        const updated = { ...item, [field]: value };
        if (
          field === 'tipo' &&
          (value === 'testo_libero' || value === 'data' || value === 'numerico')
        ) {
          updated.opzioni = null;
        } else if (field === 'tipo' && !updated.opzioni) {
          updated.opzioni = [];
        }
        return updated;
      });

      return [
        {
          ...prev[0],
          definizioniColonne: newDefinizioni,
          colonne: newDefinizioni.map((colonna) => colonna.nomeColonna),
        },
      ];
    });
  };

  const openNewValueModal = (rowIndex) => {
    setIsValoreModalOpen(true);
    setSelectedIndex(rowIndex);
  };

  const closeNewValueModal = () => setIsValoreModalOpen(false);

  const openNuovaCategoriaModal = () => setIsNuovaCategoriaModalOpen(true);

  const handleCreateCategory = async (nuovaCategoria) => {
    const newLabel = nuovaCategoria.nome || '';

    const alreadyExists = categorieSchede.some(
      (category) => category.label?.toLowerCase() === newLabel.toLowerCase(),
    );

    if (alreadyExists) {
      reportError(`La categoria "${newLabel}" esiste già.`, 'Attenzione!');
      return;
    }

    const payload = {
      ...nuovaCategoria,
      cancellato: false,
      consulenteId,
    };

    try {
      await createCustomCategory(payload);

      const responseCustomCategories =
        await getCustomCategoriesByConsultantId(consulenteId);

      const std = categorieSchede.filter((c) => !c.isCustom);

      const custom = responseCustomCategories
        .map((c) => ({
          value: c.nome.toUpperCase().replace(/\s+/g, '_'),
          label: c.nome,
          isCustom: true,
          id: c.id,
          unitaMisura: c.unitaMisura,
          tipoControllo: c.tipoControllo,
          consulenteId: c.consulenteId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setCategorieSchede([...std, ...custom]);
      handleOpenSnackbar('Categoria creata con successo!');
    } catch (error) {
      reportApiError(error);
    }
  };

  const handleDeleteCategory = async (category) => {
    setTwoActionsAlertDialog({
      open: true,
      title: 'Conferma eliminazione',
      message: `Sei sicuro di voler eliminare la categoria "${category.label}"?`,
    });
    setCategoryToDelete(category);
  };

  const handleCloseTwoActionsAlertDialog = () => {
    setTwoActionsAlertDialog({
      open: false,
      title: '',
      message: '',
    });
    setCategoryToDelete(null);
  };

  const handleConfirmDeleteCategory = async () => {
    if (!categoryToDelete) return;

    try {
      await deleteCustomCategory(categoryToDelete.id);

      // REFRESH solo delle custom categories
      const responseCategorieCustom =
        await getCustomCategoriesByConsultantId(consulenteId);
      const custom = responseCategorieCustom
        .map((c) => ({
          value: c.nome.toUpperCase().replace(/\s+/g, '_'),
          label: c.nome,
          isCustom: true,
          id: c.id,
          unitaMisura: c.unitaMisura,
          tipoControllo: c.tipoControllo,
          consulenteId: c.consulenteId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setCategorieSchede((prev) => {
        const std = prev.filter((c) => !c.isCustom); // tieni solo le standard
        return [...std, ...custom]; // aggiorna custom
      });
      handleOpenSnackbar('Categoria eliminata con successo!');
    } catch (error) {
      reportApiError(error);
    } finally {
      handleCloseTwoActionsAlertDialog();
    }
  };

  const deleteOpzioneRow = (rowIndex) => {
    setScheda((prev) => [
      {
        ...prev[0],
        definizioniColonne: prev[0].definizioniColonne.map((colonna, index) =>
          index === selectedIndex
            ? {
                ...colonna,
                opzioni: colonna.opzioni.filter(
                  (_opzione, i) => i !== rowIndex,
                ),
              }
            : colonna,
        ),
      },
    ]);
  };

  const handleSaveNewOpzioni = (newOpzioni) => {
    setScheda((prev) => [
      {
        ...prev[0],
        definizioniColonne: prev[0].definizioniColonne.map((colonna, index) =>
          index === selectedIndex
            ? {
                ...colonna,
                opzioni: newOpzioni,
              }
            : colonna,
        ),
      },
    ]);
  };

  const deleteRow = (rowIndex) => {
    setScheda((prev) => [
      {
        ...prev[0],
        definizioniColonne: prev[0].definizioniColonne.filter(
          (_item, index) => index !== rowIndex,
        ),
      },
    ]);
  };

  /*
   * The reminder has no endpoints of its own: it is a pair of fields on the
   * scheda DTO, so it rides the same GET/PUT as the rest of this screen. Both
   * handlers below only touch local state - the single write happens in
   * handleSaveScheda, and a removal is that same PUT with both fields nulled.
   */

  const handleReminderChange = (
    reminderStyle,
    reminderMessage,
    { isPartial = false } = {},
  ) => {
    setScheda((prev) => [{ ...prev[0], reminderStyle, reminderMessage }]);
    setReminderIsPartial(isPartial);
    setEdit(true);
  };

  const handleReminderRemove = () => {
    setScheda((prev) => [
      { ...prev[0], reminderStyle: null, reminderMessage: null },
    ]);
    setReminderIsPartial(false);
    setEdit(true);
  };

  const handleSaveScheda = () => {
    let schedaToSave = {
      ...scheda[0],
      cadenza: scheda[0].cadenza ?? 'ALTRO', // Se è null, diventa ALTRO
      colonne: scheda[0].definizioniColonne.map(
        (colonna) => colonna.nomeColonna,
      ),
    };

    const isCustom = !!schedaToSave.categoriaPersonalizzataId;

    schedaToSave = {
      ...schedaToSave,
      categoria: isCustom
        ? 'PERSONALIZZATA'
        : schedaToSave.categoria || 'SCHEDA_GENERICA',
    };

    const repartoPredefinito = reparti
      .filter((reparto) => reparto.repartoDefault)
      .map((reparto) => reparto.id);

    schedaToSave.reparti = [
      ...new Set([...repartoPredefinito, ...(schedaToSave.reparti || [])]),
    ];

    if (schedaToSave.reparti.length === 0) {
      reportError(
        'Occorre associare almeno un reparto alla scheda.',
        'Attenzione',
      );
      return;
    }

    const hasEmptyTitle = (schedaToSave?.definizioniColonne || []).some(
      (item) => !item.nomeColonna || item.nomeColonna.trim() === '',
    );

    if (hasEmptyTitle) {
      reportError(
        'È necessario inserire il titolo della colonna.',
        'Attenzione',
      );
      return;
    }

    const columnTitles = (schedaToSave?.definizioniColonne || []).map((item) =>
      item.nomeColonna.trim().toLowerCase(),
    );
    const hasSameTitle = new Set(columnTitles).size !== columnTitles.length;
    if (hasSameTitle) {
      reportError(
        'I titoli delle colonne devono essere univoci.',
        'Attenzione',
      );
      return;
    }

    const hasEmptyValuesForSelezione = schedaToSave?.definizioniColonne.some(
      (value) =>
        (value.tipo === 'selezione' || value.tipo === 'selezione_multipla') &&
        (!value.opzioni || value.opzioni.length === 0),
    );
    if (hasEmptyValuesForSelezione) {
      reportError(
        "È necessario aggiungere almeno un valore nel caso di tipo di colonna 'Scelta Multipla' o 'Scelta Singola'.",
        'Attenzione',
      );
      return;
    }

    const hasEmptyValuesForConformita = schedaToSave?.definizioniColonne.some(
      (value) =>
        value.tipo === 'conformita' &&
        (!value.opzioni || value.opzioni.length !== 2),
    );
    if (hasEmptyValuesForConformita) {
      reportError(
        "È necessario aggiungere due valori per colonna di tipo 'Conformità / Non Conformità'.",
        'Attenzione',
      );
      return;
    }

    if (reminderIsPartial) {
      reportError(
        'Il promemoria deve essere compilato per intero (stile e messaggio) oppure lasciato vuoto.',
        'Attenzione',
      );
      return;
    }

    if (
      schedaToSave.calendarizzato &&
      !schedaToSave.periodico &&
      schedaToSave.cadenze.length === 0
    ) {
      reportError(
        "Una volta scelta una tipologia di cadenza, bisogna associare delle cadenze nell'apposita tabella.",
        'Attenzione',
      );
      return;
    }

    if (schedaToSave.periodico) {
      const record = {
        orario: '08:00:00',
        giornoSettimana: null,
        mese: null,
        giornoMese: null,
        schedaId: schedaToSave.id,
        controlloConformitaId: schedaToSave.id,
        id: null,
      };

      switch (schedaToSave.cadenza) {
        case 'SETTIMANALE':
          record.giornoSettimana = 'MONDAY';
          break;
        case 'MENSILE':
          record.giornoMese = 1;
          break;
        case 'ANNUALE':
          record.mese = 'JANUARY';
          record.giornoMese = 1;
          break;
        default:
          break;
      }

      schedaToSave = {
        ...schedaToSave,
        cadenze: [record],
      };
    }

    // The UI holds the reminder under English names; the body carries the two
    // DTO fields instead, so the UI pair is dropped on the way out.
    const { reminderStyle, reminderMessage, ...schedaFields } = schedaToSave;

    schedaToSave = {
      ...schedaFields,
      ...reminderToDto(reminderStyle, reminderMessage),
    };

    updateGestioneOperativaSchedaById(
      aggiornamentiGestioneOperativaId,
      schedaId,
      schedaToSave,
    )
      .then(() => {
        handleOpenSnackbar('Scheda modificata con successo!');
        return getGestioneOperativaSchedaById(
          aggiornamentiGestioneOperativaId,
          schedaId,
        );
      })
      .then((responseScheda) => {
        const schedaNormalizzata = normalizeSchedaData(responseScheda.schede);
        setScheda(schedaNormalizzata);
        setReminderIsPartial(false);
        setEdit(false);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  const handleGoBack = () => {
    if (edit) {
      const confirm = window.confirm(UNSAVED_CHANGES_LEAVE_MESSAGE);
      if (!confirm) return;
    }
    history.replace(`/amministrazione/esercizi_commerciali/${esercizioId}`, {
      forceTab: 1,
    });
  };

  return (
    <div className={classes.mainContainer}>
      {loading ? (
        <SpinnerComponent size={32} />
      ) : (
        <Container>
          <OneLineTextInputComponent
            label={'Titolo:'}
            fieldname={'titolo'}
            fieldvalue={scheda[0].titolo}
            onChangeEvent={handleChangeSchedaField}
          />
          <OneLineTextInputComponent
            label={'Versione:'}
            fieldname={'numVersione'}
            fieldvalue={scheda[0].numVersione}
            onChangeEvent={handleChangeSchedaField}
          />
          <OneLineTextInputComponent
            label={'Data versione:'}
            fieldname={'dataVersione'}
            fieldvalue={scheda[0].dataVersione}
            onChangeEvent={handleChangeSchedaField}
            type="date"
          />
          <MultilineTextInputComponent
            label={'Descrizione procedura'}
            fieldname={'descrizione'}
            fieldvalue={scheda[0].descrizione}
            onChangeEvent={handleChangeSchedaField}
          />
          <div className={classes.uploadWrapper}>
            <div className={classes.uploadContainer}>
              <FileUploader
                uploadDisabled={imageUploadDisabled}
                loading={uploadingImage}
                file={newImageFile}
                onFileSelect={handleImageFileSelection}
                onUpload={() => uploadImage(newImageFile)}
                accept="image/png"
              />
              <ImageList
                immagini={scheda[0]?.immagini || []}
                loading={uploadingImage}
                onRemoveAttachment={deleteImageAttachment}
                onChangeField={changeImageField}
                urlPath={'/api/schede/immagini/'}
              />
            </div>
            <div className={classes.uploadContainer}>
              <FileUploader
                uploadDisabled={pdfUploadDisabled}
                loading={uploadingImage}
                file={newPdfFile}
                onFileSelect={handlePdfFileSelection}
                onUpload={uploadPdf}
                accept="application/pdf"
              />
              <PdfList
                files={scheda[0]?.files || []}
                onRemoveAttachment={deletePdfAttachment}
                onViewPdf={handlePdfView}
                loading={uploadingImage}
              />
            </div>
          </div>
        </Container>
      )}
      <div className={classes.tableContainer}>
        <SchedaTable
          categorieSchede={categorieSchede}
          handleCadenzaChange={handleCadenzaChange}
          handleCalendarizzatoChange={handleCalendarizzatoChange}
          handleCategoriaChange={handleCategoriaChange}
          handleDeleteCategory={handleDeleteCategory}
          handlePeriodicoChange={handlePeriodicoChange}
          isListaOrariDisabled={isListaOrariDisabled}
          loading={loading}
          openAssociazioneModal={openAssociazioneModal}
          openNuovaCategoriaModal={openNuovaCategoriaModal}
          openOrarioModal={openOrarioModal}
          scheda={scheda}
        />
        <Divider className={classes.dividerSpacing} />
        <DefinizioneColonneTable
          deleteRow={deleteRow}
          handleColumnChange={handleColumnChange}
          handleNewRow={handleNewRow}
          loading={loading}
          openNewValueModal={openNewValueModal}
          scheda={scheda}
        />
      </div>

      <ReminderSection
        reminderStyle={scheda[0]?.reminderStyle ?? null}
        reminderMessage={scheda[0]?.reminderMessage ?? ''}
        onChange={handleReminderChange}
        onRemove={handleReminderRemove}
      />

      <div className={classes.buttonWrapper}>
        <ActionButton
          secondaryButton
          label="Indietro"
          onClick={handleGoBack}
          disabled={loading}
        />
        <ActionButton
          label="Salva"
          disabled={loading}
          grayVersion={false}
          onClick={handleSaveScheda}
        />
      </div>
      {snackbar.open && (
        <CustomSnackbar
          open={snackbar.open}
          onClose={handleCloseSnackbar}
          message={snackbar.message}
        />
      )}
      {twoActionsAlertDialog.open && (
        <TwoActionsAlertDialog
          visible={twoActionsAlertDialog.open}
          title={twoActionsAlertDialog.title}
          message={twoActionsAlertDialog.message}
          onIndietroClicked={handleCloseTwoActionsAlertDialog}
          onOkClicked={handleConfirmDeleteCategory}
        />
      )}
      {isOrarioModalOpen && (
        <ModalSelezioneOrarioScheda
          theme={theme}
          open={isOrarioModalOpen}
          onClose={closeOrarioModal}
          cadenza={scheda[0].cadenza}
          cadenze={scheda[0].cadenze}
          setCadenzeToControllo={setCadenze}
          scheda={scheda}
          categorieSchede={categorieSchede}
          schedaId={scheda[0].id}
        />
      )}
      {isAssociazioneModalOpen && (
        <ModalSelezioneAssociazioneScheda
          open={isAssociazioneModalOpen}
          onClose={closeAssociazioneModal}
          reparti={reparti}
          schedaData={scheda}
          saveValues={addRepartiToScheda}
        />
      )}

      {isValoreModalOpen && (
        <AggiuntaOpzioniColonnaModal
          open={isValoreModalOpen}
          onClose={closeNewValueModal}
          columnData={scheda[0].definizioniColonne}
          selectedIndex={selectedIndex}
          deleteOpzioneRow={deleteOpzioneRow}
          handleSaveNewOpzioni={handleSaveNewOpzioni}
        />
      )}
      {isNuovaCategoriaModalOpen && (
        <NuovaCategoriaControlloModal
          open={isNuovaCategoriaModalOpen}
          onClose={() => setIsNuovaCategoriaModalOpen(false)}
          onCreate={handleCreateCategory}
        />
      )}
    </div>
  );
};

DettaglioSchedaEsercizio.propTypes = {
  esercizioId: PropTypes.string.isRequired,
  schedaId: PropTypes.string.isRequired,
};

export default DettaglioSchedaEsercizio;
